<template>
  <div v-if="myMachines">
    <slot name="activator" :open="open"></slot>
    <oie-portal-wrapper :name="name">
      <template #title>
        <h2>{{ computedTitle }}</h2>
      </template>
      <div>
        <oie-add-edit-machine-form @cancel="setActiveSlideIn(null)" @save="handleSave($event)"></oie-add-edit-machine-form>
      </div>
    </oie-portal-wrapper>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import { showMyMachinesGdprConsentModal } from '@/core/modal-service'

export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      name: ''
    }
  },
  computed: {
    ...mapGetters('myMachines', ['myMachines', 'myMachinesFilter', 'filteredMachineOwners', 'filteredMachines']),
    computedTitle() {
      return this.title || this.tStatic('saveThisMachine')
    }
  },
  beforeMount() {
    this.name = this.$attrs.id || _.uniqueId('my-machines-quick-add-slide-in-')
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    ...mapActions('myMachines', ['getMyMachines', 'getMyMachinesMetaData']),
    async open() {
      if(this.myMachinesIsLocked) {
        const consent = await showMyMachinesGdprConsentModal()
        if(consent) this.setActiveSlideIn(this.name)
      } else {
        this.setActiveSlideIn(this.name)
      }
    },
    handleSave(machine) {
      this.getMyMachines()
      this.getMyMachinesMetaData()
      this.setActiveSlideIn(null)
      this.publish('modal.show.select-machine', { machine: machine })
    }
  }
}
</script>

<style>

</style>
